import React from 'react'
import { observer } from 'mobx-react-lite'
import CardItem from './item'
import styled from 'styled-components'

type CardItemProps = {
   listCard?: any[]
   type?: string
   style?: object
   onSelect?: any
   classNameItem?: string
   className?: string
   itemsSelected?: any[]
   onDelete?: any
   imageSize?: number
   showProductLinks?: boolean
   readOnlyProductLinks?: boolean
   showMyLinkDesign?: boolean
   showSelectionStatus?: boolean
   onProductLinkChange?: (index: number, field: string, value: string) => void
}
export const ListCardStyle = styled.div`
   .card-list-content {
      overflow: hidden;
      border-top: 1px solid #f0f0f0;
      border-bottom: 1px solid #f0f0f0;
   }
   .highlight {
      background-color: #f6ffed40;
      border: 0.5px solid #b7eb8f;
   }
`
const CardItems: React.FC<CardItemProps> = observer(
   ({
      listCard,
      type,
      style = {},
      onSelect,
      classNameItem = '',
      className = '',
      itemsSelected,
      onDelete,
      imageSize,
      showProductLinks,
      readOnlyProductLinks,
      showMyLinkDesign,
      showSelectionStatus,
      onProductLinkChange
   }) => {
      const isCardSelected = (ỉtem: any) => {
         if (itemsSelected && itemsSelected.find((itemSelect) => itemSelect.id === ỉtem.id)) {
            return true
         }
         return false
      }

      return (
         <ListCardStyle className={className}>
            <div className="card-list-content" style={style}>
               {listCard?.map((item: any, index: number) => (
                  <CardItem
                     item={item}
                     key={index}
                     type={type}
                     onClick={() => (onSelect ? onSelect(item) : null)}
                     className={`${classNameItem} ${isCardSelected(item) ? 'highlight' : ''}`}
                     onDelete={() => (onDelete ? onDelete(index) : null)}
                     onChange={(value: any) => (item.qty = value)}
                     imageSize={imageSize}
                     showProductLinks={showProductLinks}
                     readOnlyProductLinks={readOnlyProductLinks}
                     showMyLinkDesign={showMyLinkDesign}
                     showSelectionStatus={showSelectionStatus}
                     isSelected={isCardSelected(item)}
                     onProductLinkChange={(field: string, value: string) => onProductLinkChange?.(index, field, value)}
                  />
               ))}
            </div>
         </ListCardStyle>
      )
   }
)

export default CardItems
